import { render, staticRenderFns } from "./hanDongTextArea.vue?vue&type=template&id=50f65eea&scoped=true"
import script from "./hanDongTextArea.vue?vue&type=script&lang=js"
export * from "./hanDongTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f65eea",
  null
  
)

export default component.exports